import axios from 'axios'
import Vapi from 'vuex-rest-api'
import Vue from 'vue'

const api = new Vapi({
  axios,
  state: {
    users: {
      admin: [],
      expert: [],
      attendee: [],
    },
    attendees2020: [],
    usersReady: false,
  },
})
  .get({
    action: 'getUsers',
    property: 'users',
    path: '/users',
    onSuccess(s, { data }) {
      Object.keys(s.users).forEach((role) => {
        Vue.set(s.users, role, [])
      })

      data.forEach((item) => {
        try {
          const role = item.role.alias.toLowerCase()
          if (!s.users[role]) {
            Vue.set(s.users, role, [])
          }
          s.users[role].push(item)
        } catch (e) {
          console.warn(e)
        }
      })
      s.usersReady = true
    },
  })
  .get({
    action: 'getAttendees2020',
    property: 'attendees2020',
    path: '/users?summer2020=1',
    onSuccess(s, { data }) {
      s.attendees2020 = data
    },
  })
  .get({
    action: 'getUser',
    property: 'user',
    path: ({ id }) => `/user/${id}`,
  })
  .post({
    action: 'updateUser',
    property: 'updateResult',
    path: '/profile',
  })
  .delete({
    action: 'deleteProfile',
    path: '/profile',
  })
  .getStore({ namespaced: true })

export default {
  ...api,
  mutations: {
    cleanUser(s) {
      s.user = null
    },
    ...api.mutations,
  },
  getters: {
    getUserId:
      (s) =>
      (userId, attendees2020 = false) => {
        const _find = (list) => list.find(({ id }) => id === userId)

        for (let key of Object.keys(s.users)) {
          const user = _find(s.users[key])
          if (user) return user
        }

        if (attendees2020) {
          return _find(s.attendees2020)
        }
      },
  },
}
